import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NewslettersRoutingModule } from './newsletters-routing.module';
import { NewslettersListComponent } from './components/newsletters-list/newsletters-list.component';
import { NewslettersAddComponent } from './components/newsletters-add/newsletters-add.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';
import { IonicModule } from '@ionic/angular';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';


@NgModule({
  declarations: [
    NewslettersListComponent,
    NewslettersAddComponent,
    NewslettersListComponent
  ],
  imports: [
    CommonModule,
    NewslettersRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    IonicModule.forRoot(),
    NgxMatSelectSearchModule
  ]
})
export class NewslettersModule { }
